/*
 * The anonymous page-view counter.
 *
 * Sent with `fetch` rather than `$http`: the endpoint takes no token, and `$http`'s interceptor
 * requires a session - so the first transition of a session (the landing page) was rejected before
 * it was ever sent, and every session under-counted the page people actually open most.
 *
 * Extracted in step 27 of #614. Three callers had their own copy of this and only one of them was
 * still Angular, so it belongs on its own rather than in a service that is on its way out.
 */
const pageView = page =>
  fetch('/api/log/pageview', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ page: page }),
  })

export default pageView
